import { render, staticRenderFns } from "./SpielerEinladenComp.vue?vue&type=template&id=828607b6&scoped=true&"
import script from "./SpielerEinladenComp.vue?vue&type=script&lang=ts&"
export * from "./SpielerEinladenComp.vue?vue&type=script&lang=ts&"
import style0 from "./SpielerEinladenComp.vue?vue&type=style&index=0&id=828607b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828607b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAutocomplete,VBtn,VDialog})
